var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.62134C13.9529 5.62134 15.2702 6.4649 16.0214 7.16978L18.9565 4.30401C17.1538 2.62845 14.808 1.60001 12 1.60001C7.93246 1.60001 4.41957 3.93423 2.70935 7.33156L6.07202 9.94312C6.91557 7.43556 9.24979 5.62134 12 5.62134Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.984 12.2311C21.984 11.376 21.9147 10.752 21.7644 10.1049H12V13.9644H17.7316C17.616 14.9236 16.992 16.368 15.6053 17.3387L18.8871 19.8809C20.8516 18.0667 21.984 15.3973 21.984 12.2311Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08353 14.0569C5.86398 13.4098 5.73686 12.7164 5.73686 12C5.73686 11.2835 5.86398 10.5902 6.07198 9.9431L2.70931 7.33154C2.00442 8.74132 1.59998 10.3244 1.59998 12C1.59998 13.6755 2.00442 15.2587 2.70931 16.6684L6.08353 14.0569Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 22.4C14.8081 22.4 17.1654 21.4756 18.8872 19.8809L15.6054 17.3387C14.7272 17.9511 13.5485 18.3787 12.0001 18.3787C9.24984 18.3787 6.91561 16.5644 6.08361 14.0569L2.72095 16.6684C4.43117 20.0658 7.9325 22.4 12.0001 22.4Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.48520c7a3176b2eb7fdea514e6a0f323.svg";
export { ForwardRef as ReactComponent };